// Copyright (c) 2021, Comsearch, Inc., All rights reserved

/**
 * @typedef {Object} callsignCascadeAggregateGroup
 * @property {Array<number>} matchedSegmentEndIds - segment end ids which should be cascaded with the trigger segment end data
 * @property {number} triggeredSegmentEndId - segment end id that was updated and has triggered the callsign cascade.
 */

/**
 * Takes callsign cascade input from the Callsign Cascade form and reduces it to only the segment ends that we want to update
 * @param {Array<callsignCascadeAggregateGroup>} callsignCascadeInput - this comes from Callsign Cascade redux form
 * @returns {Array<callsignCascadeAggregateGroup>} preparedCascadeUpdateData - same as the input but any aggregates which weren't supposed to cascade are removed.
 */

const prepareCascadeUpdateData = callsignCascadeInput => (
  callsignCascadeInput.reduce((a, d) => {
    if (d.matchedSegmentEndIds.length) {
      a.push(d)
    }
    return a
  }, [])
)

export default prepareCascadeUpdateData
